import { request, toastError } from '@/utils';
import { useMutation } from 'react-query';

export const useAuthDapp = (onSuccess?: (accessToken: string) => void) => {
  const url = '/oauth/authorize';
  return useMutation(
    ({ templateId }: { templateId: string }) =>
      request.post<{ is_success: boolean; access_token: string }>(url, { template_id: templateId }),
    {
      onSuccess: res => {
        if (res.is_success) {
          onSuccess?.(res.access_token);
        }
      },
      onError(err: any) {
        toastError(err || 'failed');
      },
    },
  );
};
